import { GB_VAT_AMOUNT, IE_VAT_AMOUNT } from '@npi/buddy-utils';
import { CountryCode } from 'libphonenumber-js';

export interface TaxRule {
    name: string;
    rate: number; // e.g., 0.23 for 23%
    includedInPrice: boolean;
}

export interface CountryConfig {
    name: string;
    defaultLocale: string;
    supportedLocales: string[];
    defaultCurrency: string;
    supportedCurrencies: string[];
    addressFormat: string;
    postalCodeType: 'postcode' | 'eircode' | 'zipcode' | 'pin';
    phoneCode: string;
    taxRules: TaxRule[];
    requiresRegion?: boolean;
    // TODO: (KM) Add dateFormat
}

// FIXME: (KM) Expected TypeError since we need to specify properties for each country and extend with XI
export const countryConfig: Record<CountryCode, CountryConfig> = {
    CH: {
        name: 'Switzerland',
        defaultLocale: 'de-CH',
        supportedLocales: ['de-CH', 'fr-CH', 'it-CH'],
        defaultCurrency: 'CHF',
        supportedCurrencies: ['CHF', 'EUR', 'USD'],
        addressFormat: 'intl',
        postalCodeType: 'postcode',
        phoneCode: '+41',
        taxRules: [{ name: 'MWST', rate: 0.077, includedInPrice: false }],
    },
    GB: {
        name: 'United Kingdom',
        defaultLocale: 'en-GB',
        supportedLocales: ['en-GB'],
        defaultCurrency: 'GBP',
        supportedCurrencies: ['GBP'],
        addressFormat: 'uk',
        postalCodeType: 'postcode',
        phoneCode: '+44',
        taxRules: [{ name: 'VAT', rate: 0.2, includedInPrice: true }],
    },
    IE: {
        name: 'Ireland',
        defaultLocale: 'en-IE',
        supportedLocales: ['en-IE'],
        defaultCurrency: 'EUR',
        supportedCurrencies: ['EUR'],
        addressFormat: 'ie',
        postalCodeType: 'eircode',
        phoneCode: '+353',
        taxRules: [{ name: 'VAT', rate: 0.23, includedInPrice: true }],
    },
    XI: {
        name: 'Northern Ireland',
        defaultLocale: 'en-GB',
        supportedLocales: ['en-GB'],
        defaultCurrency: 'GBP',
        supportedCurrencies: ['GBP'],
        addressFormat: 'uk',
        postalCodeType: 'postcode',
        phoneCode: '+44',
        taxRules: [{ name: 'VAT', rate: 0.2, includedInPrice: true }],
    },
};

// #region Helpers
export const isIreland = ((process.env.REGION as CountryCode) ?? 'IE') === 'IE';

export const getCountryName = (alpha2code?: string) => {
    switch (alpha2code) {
        // (KM) Special case: Northern Ireland defaults to United Kingdom for reporting purposes
        case 'XI':
        case 'GB':
            return countryConfig.GB.name;

        default:
            return countryConfig.IE.name;
    }
};

export const getVatAmount = () => {
    if (isIreland) {
        return IE_VAT_AMOUNT;
    }
    return GB_VAT_AMOUNT;
};

// #endregion Helpers
